const mensagem_fixa_biometria_mudar_para_pendente = '(Biometria - Será enviado uma validação via SMS e E-mail ao cliente)'

export { mensagem_fixa_biometria_mudar_para_pendente }
